import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { PrivatePageComponent } from '@pages/private-pages/private-page.component';
import { ComponentsModule } from '@shared/components/components.module';
import { SharedModule } from '@shared/shared.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BaggageAccordionComponent } from './baggage-accordion/baggage-accordion.component';
import { ModalExtrasComponent } from './extras-modal/extras-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { CreateExtrasComponent } from './create/create-extras.component';
import { ExtrasPageComponent } from './extras-page.component';
import { OverviewPageComponent } from './overview/overview-page.component';
import { LoungeAccordionComponent } from './lounge-accordion/lounge-accordion.component';
import { AirportAssistanceAccordionComponent } from './airport-assistance-accordion/airport-assistance-accordion.component';

const routes: Routes = [
  {
    path: 'extras',
    component: PrivatePageComponent,
    children: [
      {
        path: 'create',
        component: ExtrasPageComponent
      },
      {
        path: 'overview',
        component: OverviewPageComponent
      },
      { path: '', redirectTo: '/overview', pathMatch: 'full' },
    ]
  },
];

@NgModule({
  imports: [FormsModule, RouterModule.forChild(routes), CommonModule, ComponentsModule,
    AccordionModule.forRoot(), TranslateModule.forChild(), SharedModule, ReactiveFormsModule ],
  declarations: [ExtrasPageComponent, BaggageAccordionComponent, ModalExtrasComponent, CreateExtrasComponent, OverviewPageComponent, LoungeAccordionComponent, AirportAssistanceAccordionComponent],
  bootstrap: [ExtrasPageComponent, CreateExtrasComponent, OverviewPageComponent]
})
export class ExtrasPageModule { }
